module.exports = __webpack_public_path__ + "f205b5d530d5a541ea5fa76cac17a223.svg";